<template>
  <div>
    <Header />
    <div class="pt80">
      <div id="section1">
        <div class="container">
          <div class="th">
            <span>{{ $t("header.nav5") }} </span>
            <i class="el-icon-arrow-right"></i>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="th2">{{ $t("about.th") }}</div>
          <div class="txt">
            {{ $t("about.tips") }}
          </div>
          <div class="txt">
            {{ $t("about.tips2") }}
          </div>
        </div>
      </div>
      <!-- <div id="section2">
        <div class="container">
          <div class="timeline">
            <div class="li"><i></i>2019年公司成立</div>
            <div class="li">
              <i></i>
              2020年与尼日利亚财政部合作，为尼日利亚搭建NQR系统
            </div>
            <div class="li"><i></i>2022年2月获得尼日利亚的支付牌照</div>
            <div class="li">
              <i></i>
              2023年9月即时通讯工具-BudChat在尼日利亚全面上线
            </div>
            <div class="li"><i></i>2024年4月新加坡公司成立</div>
            <div class="li"><i></i>2024年8月获得香港MSO牌照</div>
            <div class="li"><i></i>2024年9月获得坦桑尼亚牌照</div>
            <div class="line"></div>
            <div class="bg"><img src="@/assets/about-2.png" alt="" /></div>
          </div>
        </div>
      </div> -->

      <section id="address">
        <div class="container">
          <div class="d-flex">
            <div class="address">
              <!-- <div
                class="add_item"
                :class="{ active: currentKey == 'a1' }"
                @click="currentKey = 'a1'"
              >
                <div class="th2"><i></i>中国总部</div>
                <div class="add_info">
                  <p>Zantech  Limited</p>
                  <p>联系电话：0571-87175575</p>
                  <p>邮箱地址：info@zxfintec.com</p>
                  <p>
                    公司地址：杭州市余杭区良渚街道金昌路2800号（洋帆中心）7号楼
                  </p>
                </div>
              </div> -->
              <div
                class="add_item"
                :class="{ active: currentKey == 'a2' }"
                @click="currentKey = 'a2'"
              >
                <div class="th2"><i></i>{{ $t("address.hk") }}</div>
                <div class="add_info">
                  <p>Singloh Technology Limited</p>
                  <div class="d-flex">
                    <p>{{ $t("address.address") }}：</p>
                    <p>
                      Room No.05 15/F <br />
                      Radio City <br />
                      505-511 Hennesy Road <br />
                      Causeway Bay<br />
                      Hong Kong
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div
                class="add_item"
                :class="{ active: currentKey == 'a3' }"
                @click="currentKey = 'a3'"
              >
                <div class="th2"><i></i>尼日利亚</div>
                <div class="add_info">
                  <p>BUD Infrastructure Limited</p>
                  <div class="d-flex">
                    <p>公司地址：</p>
                    <p>
                      21B Fatai Idowu Arobieke St<br />
                      Lekki Phase 1<br />
                      Lagos<br />
                      Nigeria
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="add_item"
                :class="{ active: currentKey == 'a4' }"
                @click="currentKey = 'a4'"
              >
                <div class="th2"><i></i>坦桑尼亚</div>
                <div class="add_info">
                  <p>MONEYPESA TANZANIA LIMITED</p>
                  <div class="d-flex">
                    <p>公司地址：</p>
                    <p>
                      House 47 Block 47<br />
                      Makumbusho<br />
                      Dar es Salaam<br />
                      Tanzania
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="add_item"
                :class="{ active: currentKey == 'a5' }"
                @click="currentKey = 'a5'"
              >
                <div class="th2"><i></i>哈萨克斯坦</div>
                <div class="add_info">
                  <p>Hong Kong KZPAY Technology Limited</p>
                </div>
              </div>
              <div
                class="add_item"
                :class="{ active: currentKey == 'a6' }"
                @click="currentKey = 'a6'"
              >
                <div class="th2"><i></i>新加坡</div>
                <div class="add_info">
                  <p>ZANTECH INNOVATION PTE. LTD.</p>
                  <div class="d-flex">
                    <p>公司地址：</p>
                    <p>
                      112 ROBINSON ROAD<br />
                      #03-01<br />
                      ROBINSON 112<br />
                      SINGAPORE (068902)
                    </p>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="map">
              <div v-for="(ad, key) in address" :key="key">
                <div
                  class="circle"
                  :style="{ top: ad.x + 'px', left: ad.y + 'px' }"
                  @click="currentKey = key"
                >
                  <div v-if="key == currentKey" class="check">
                    <div class="wave"></div>
                  </div>
                  <div v-else class="dot"></div>
                </div>
              </div>
            </div>
          </div>

          <img src="@/assets/about-3.png" width="100%" />
        </div>
      </section>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import "@/assets/css/animate.css";
export default {
  name: "personal",
  components: { Header, Footer },
  data() {
    return {
      currentKey: "a2",
      address: {
        // a1: { x: 127, y: 535, name: "中国总部" },
        a2: { x: 162, y: 518, name: "香港" }
        // a3: { x: 188, y: 323, name: "尼日利亚" },
        // a4: { x: 213, y: 391, name: "坦桑尼亚" },
        // a5: { x: 109, y: 428, name: "哈萨克斯坦" },
        // a6: { x: 203, y: 518, name: "新加坡" }
      }
    };
  },
  watch: {
    // 监听器会在表达式的值变化后执行
    currentKey: {
      handler: function() {
        clearInterval(this.timer);
        // this.timer = setInterval(this.nextKey, 3000);
      },
      immediate: true // 组件加载立即执行一次
    }
  },
  mounted() {
    localStorage.setItem("channel", this.$route.query.channel);
  },
  methods: {
    nextKey() {
      const keys = Object.keys(this.address);
      const currentIndex = keys.findIndex(key => key === this.currentKey);
      const nextIndex = (currentIndex + 1) % keys.length;
      console.log(nextIndex);
      this.currentKey = keys[nextIndex];
    }
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.pt80 {
  padding-top: 80px;
}

.container {
  padding: 0;
}

#section1 {
  height: 429px;
  background-image: url(~@/assets/about-1.png);
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  .container {
    position: relative;
  }
  .th {
    margin-top: 18px;
    font-weight: 500;
    font-size: 20px;
    color: #3b3b3b;
    line-height: 20px;
    i {
      &:last-child {
        margin-left: -20px;
      }
    }
  }
  .th2 {
    margin-top: 11px;
    margin-bottom: 26px;
    font-weight: 300;
    font-size: 64px;
    color: #1485ef;
    line-height: 64px;
  }
  .txt {
    width: 894px;
    font-weight: 350;
    font-size: 16px;
    color: #888888;
    line-height: 28px;
  }
}

#section2 {
  .timeline {
    margin-top: 20px;
    position: relative;
    .li {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 20px;
      color: #4e4e4e;
      line-height: 60px;
      i {
        margin-right: 25px;
        display: inline-block;
        width: 18px;
        height: 18px;
        background: #1485ef;
        border: 4px solid rgba(20, 133, 239, 0.4);
        background-clip: padding-box;
        border-radius: 50%;
      }
    }
    .line {
      position: absolute;
      top: 30px;
      left: 8px;
      width: 0px;
      height: 360px;
      border: 2px dashed rgba(20, 133, 239, 0.4118);
    }
    .bg {
      position: absolute;
      top: 145px;
      left: 476px;
      width: 389px;
      img {
        width: 100%;
      }
    }
  }
  .content {
    position: relative;
    padding-top: 163px;
    padding-left: 29px;
    .th2 {
      font-weight: 300;
      font-size: 42px;
      color: #1485ef;
      line-height: 51px;
    }
    .th3 {
      font-weight: 300;
      font-size: 42px;
      line-height: 51px;
      color: #000000;
    }
    .btn {
      margin-top: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 169px;
      height: 54px;
      background: linear-gradient(270deg, #1485ef 0%, #1485ef 100%);
      border-radius: 30px;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      span {
        margin-right: 10px;
      }
    }
    .pic {
      position: absolute;
      top: -100px;
      left: 140px;
    }
  }
}
#address {
  // height: 540px;
  // background: #f4f4f4;
  .container {
    padding: 0;
  }
  .address {
    margin-top: 38px;
    margin-right: 16px;
    .add_item {
      margin-bottom: 10px;
      .th2 {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #8d8d8d;
        line-height: 29px;
        cursor: pointer;
        i {
          margin-right: 9px;
          display: block;
          width: 10px;
          height: 10px;
          background: #c9c9c9;
          border-radius: 10px;
        }
      }
      .add_info {
        display: none;
        margin-left: 19px;
        width: 280px;
        p {
          margin-bottom: 0;
          font-weight: 400;
          font-size: 14px;
          color: #8d8d8d;
          line-height: 29px;
        }
      }
      &.active {
        .th2 {
          color: #1485ef;
          i {
            background: #1485ef;
          }
        }
        .add_info {
          display: block;
        }
      }
    }
  }
  .map {
    position: relative;
    margin-top: 58px;
    width: 682px;
    height: 345px;
    background: url(~@/assets/map.png) no-repeat;
    background-size: cover;
    .circle {
      position: absolute;
      cursor: pointer;
      .dot {
        width: 10px;
        height: 10px;
        background: #ffffff;
        border: 2px solid #1485ef;
        border-radius: 50%;
      }
      .check {
        width: 15px;
        height: 15px;
        background: #1485ef;
        border-radius: 50%;
        .wave {
          position: absolute;
          top: 0;
          left: 0;
          transform: translate(-50%, -50%);
          width: 15px;
          height: 15px;
          background: #1485ef;
          border-radius: 50%;
          animation: pulse 3s infinite;
        }
      }
    }
    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      100% {
        transform: scale(2);
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about.vue